import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import LegalPublicLayout from "./LegalPublicLayout";
import { LegalSectionBody } from "./LegalSectionBody";
import type { LegalSectionBlock } from "./legalSectionTypes";

const sections: LegalSectionBlock[] = [
  {
    title: "1. Tipul serviciilor",
    content: "AIFoiParcurs oferă servicii digitale, software, fără livrare fizică.",
  },
  {
    title: "2. Modalitate de livrare",
    content:
      "Livrarea serviciilor se realizează electronic, prin activarea contului sau a funcționalităților aplicației.",
  },
  {
    title: "3. Timp de livrare",
    content: "Accesul la servicii este oferit imediat după confirmarea plății.",
    footer:
      "În cazuri excepționale, de exemplu probleme tehnice, activarea poate dura până la 24 de ore.",
  },
  {
    title: "4. Condiții de acces",
    content: "Pentru utilizarea serviciilor este necesar:",
    bullets: ["un cont activ în platformă;", "conexiune la internet."],
  },
  {
    title: "5. Limitări",
    content: "AIFoiParcurs nu este responsabil pentru întârzieri cauzate de:",
    bullets: [
      "probleme tehnice externe;",
      "conexiunea utilizatorului;",
      "indisponibilitatea temporară a serviciilor terțe.",
    ],
  },
  {
    title: "6. Contact",
    content: "Pentru orice problemă legată de livrare:",
    footer: "aifoiparcurs@visaj.ro",
  },
];

export default function PoliticaLivrarePage() {
  return (
    <LegalPublicLayout>
      <Seo {...seoFromPublicPage("/politica-de-livrare")} />
      <main className="legal-doc">
        <div className="legal-doc__inner">
          <Link to="/" className="legal-doc__back">
            Înapoi la pagina principală
          </Link>

          <div className="legal-doc__panel">
            <p className="legal-doc__eyebrow">Politica de livrare</p>
            <h1 className="legal-doc__title">Politica de livrare</h1>

            <div className="legal-doc__sections">
              {sections.map((section) => (
                <LegalSectionBody key={section.title} section={section} />
              ))}
            </div>
          </div>
        </div>
      </main>
    </LegalPublicLayout>
  );
}
